import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  TextField,
  Menu,
  MenuItem,
} from "@material-ui/core";

const UserSort = ({
  anchorEl,
  handleClose,
  setSort,
  selectedTab,
  ...props
}) => {

  const sortData = [
    { title: "Restaurant Name", disabled: true },
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: "Date & Time", disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: 'Date & Time 🠓', disabled: false },
  ];
  const newsortData = [
    { title: `${selectedTab == "1" ? "Request" 
              : selectedTab == "2" ? "Order" 
              : selectedTab == "3" ? "Request"
              : selectedTab == "4" ? "Transactions"
              : selectedTab == "5" ? "Nominated"
              : selectedTab == "6" ? "Favourite added/removed"
              : selectedTab == "7" ? "Reviews"
              : selectedTab == "8" ? "Referrals" 
              : selectedTab == "9" ? "Miscellaneous" 
              : selectedTab == "10" ? "Tickets" 
              : selectedTab == "11" ? "Date & Time"
              : selectedTab == "12" ? "Date & Time" : "offers"}`, disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: 'Date & Time 🠓', disabled: false },
  ];
 

    const nomiData = [{ title: 'Restaurant Name', disabled: true },
    { title: 'A-Z', disabled: false },
    { title: 'Z-A', disabled: false }, { title: 'Nominated', disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: 'Date & Time 🠓', disabled: false }];

    const sortDateOnly = [{ title: 'Date', disabled: true },
    { title: 'Latest', disabled: false },
    { title: 'Oldest', disabled: false }]

  const refree = [
    { title: "Referred Date", disabled: true },
    { title: "Latest", disabled: false },
    { title: "Oldest", disabled: false },
  ];

    const walletData = [{ title: 'Payment To (Name)', disabled: true },
    { title: 'A-Z', disabled: false },
    { title: 'Z-A', disabled: false }, { title: 'Transactions', disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: 'Date & Time 🠓', disabled: false }];

    let sortingData = [];

    if(selectedTab == "1") sortingData = newsortData;
    else if(selectedTab == "2") sortingData = newsortData;
    else if(selectedTab == "3") sortingData = newsortData;
    else if(selectedTab == "4") sortingData = walletData;
    else if(selectedTab == "5") sortingData = nomiData;
    else if(selectedTab == "6") sortingData = newsortData;
    else if(selectedTab == "7") sortingData = newsortData;
    else if(selectedTab == "8") sortingData = newsortData;
    else if(selectedTab == "9") sortingData = newsortData;
    else if(selectedTab == "10") sortingData = newsortData;
    else if(selectedTab == "11") sortingData = newsortData;
    else if(selectedTab == "12") sortingData = newsortData;
    else if(selectedTab == "13") sortingData = newsortData;
    else if(selectedTab == "14") sortingData = newsortData;

  return (
    <>
      {
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {sortingData.map((data, index) => {
            return (
              <MenuItem
                value={data.title}
                key={index}
                onClick={setSort(data.title)}
                disabled={data.disabled}
                style={{fontWeight:"700"}}  
              >
                {data.title}
              </MenuItem>
            );
          })}
        </Menu>
      }
    </>
  );
};

export default UserSort;
